import React from 'react';
import 'normalize.css';
import './CSS/home.css';
import gallery_corner from '../src/Images/gallery_corner.jpg';
import gallery_table from '../src/Images/Optimized-gallery_table.jpg';
import bandw_example1 from '../src/Images/bandw_example1.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import Footer from './Footer';


function Home() {

  const renderTooltip = (name) => (
    <Tooltip id="button-tooltip">
      {name}
    </Tooltip>
  );  
  
  return (
    <div className="container">	
      <div className="homepage_grid">
        <div className="homepage_grid__item">
          <article className="image__card red__salsa">
            <div className="img__container">
              <div className="image">			
                <img src={bandw_example1} alt="Gallery corner" />
              </div> 
            </div>
          </article>
        </div>
        <div className="homepage_grid__item">
          <article className="card orange__red">
            <h1 className="title__card">Sombrero Printmaking</h1>
          </article>
        </div>
        <div className="homepage_grid__item">
          <article className="card queen__blue">
            <h3 className="small__card"><span className="monoton">Hi</span>, I'm Dave. A printmaker and artist who lives in Chesterfield.</h3>
          </article>
        </div>
        <div className="homepage_grid__item">
          <article className="card pansy__purple">
          <h3 className="homepage_text">I live with my girlfriend, our daughters, two cats, a rabbit, a hamster and several fish.</h3>
          <h3 className="homepage_text">As well as making art, I teach linoprint workshops and offer 1-1 tutoring. I also like running, cake, going on adventures and being a bit <span className="monoton">odd</span>.</h3>
          </article>
        </div>
        <div className="homepage_grid__item">
          <article className="card pistachio">
            <h3 className="small__card">"Beautiful prints, they look great framed and make great gifts"</h3>
            <h3 className="monoton">Etsy</h3>
            <h3 className="small__card">Susan, April 2019</h3>
          </article>
        </div>
        <div className="homepage_grid__item">
        <div className="img__container">
            <div className="image">			
              <img src={gallery_corner} alt="Gallery hanging" />
            </div> 
          </div>
        </div>
        <div className="homepage_grid__item">
          <div className="img__container">
            <div className="image">			
              <img src={gallery_table} alt="Gallery hanging" />
            </div> 
          </div>
        </div>
        <div className="homepage_grid__item">
          <article className="card independence">
            <h3 className="small__card">I've been running Linoprint workshops since 2018, and also teach 1-1 or in small groups. All resources are provided!</h3>
            <a href="/workshops"><h3 className="small__monoton underline">Find out more</h3></a>
          </article>
        </div>
        <div className="homepage_grid__item">
          <article className="card red__salsa">
            <h3 className="homepage_text">Check out my work!</h3>
            <a href="/gallery"><h3 className="monoton underline">Gallery</h3></a>
          </article>
        </div>
        <div className="homepage_grid__item">
          <article className="card yellow__orange">
            <h3 className="homepage_text">Find me on:</h3>
            <div className="icon__container">
              <OverlayTrigger
                placement="left"
                delay={{ show: 150, hide: 200 }}
                overlay={renderTooltip('Instagram')}
              >
                <a target="blank" href="https://www.instagram.com/sombrero_printmaking/?hl=en"><FontAwesomeIcon icon={faInstagram} /></a>
              </OverlayTrigger>
              <OverlayTrigger
                placement="left"
                delay={{ show: 150, hide: 200 }}
                overlay={renderTooltip('Facebook')}
              >
                <a target="blank" href="https://www.facebook.com/Sombrero_Printmaking-215020229059381/?eid=ARDq1yIzaOX02Vrnpt3r_6gnGYY_vamnUOcgS7DBin-5JHmxeUqz7kmo1Jwfj6REyvb9WszH3A7FHvyF"><FontAwesomeIcon icon={faFacebook} /></a>
              </OverlayTrigger>
              <OverlayTrigger
                placement="left"
                delay={{ show: 150, hide: 200 }}
                overlay={renderTooltip('Youtube')}
              >
                <a target="blank" href="https://www.youtube.com/channel/UCDsRAuVhZ2uS0E2nwgiLPQA"><FontAwesomeIcon icon={faYoutube} /></a>
              </OverlayTrigger>
            </div>
          </article>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Home;
